<p-dialog [(visible)]="display" [resizable]="false" [modal]="true" [style]="{'width': '760px'}" (onHide)="hide()"
	appendTo="body" styleClass="prtg-export-map-dialog">
	<p-header>
		<span>Export MAP to PRTG</span>
	</p-header>

	@if (loading) {
	<div class="mb-2">Loading PRTG agents…</div>
	}

	@if (errorMessage) {
	<div class="mb-2 text-danger">{{ errorMessage }}</div>
	}

	@if (!loading && !errorMessage && dropdownOptions.length > 0) {

	<fieldset class="prtg-panel">
		<legend>PRTG Server</legend>
		<div class="form-row">
			<label class="form-label">Server Settings:</label>
			<div class="form-input">
				<p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedGuid" [style]="{'width': '100%'}"
					appendTo="body" placeholder="Select a PRTG server"
					(onChange)="onPrtgSettingsChanged()"></p-dropdown>
			</div>
			<div class="form-side-spacer"></div>
		</div>
		<div class="form-row">
			<label class="form-label">Summary:</label>
			<div class="form-input">
				<input type="text" pInputText [value]="serverSummary" readonly style="width: 100%" />
			</div>
			<div class="form-side-spacer"></div>
		</div>
	</fieldset>

	<fieldset class="prtg-panel">
		<legend>Export Settings</legend>

		<div class="form-row">
			<label class="form-label">Map Name:</label>
			<div class="form-input">
				<input type="text" pInputText [(ngModel)]="mapName" style="width: 100%"
					placeholder="New PRTG map name" />
			</div>
			<button type="button" pButton class="form-side-btn" label="Browse..."
				(click)="browseMapName()" [disabled]="!selectedGuid"></button>
		</div>

		<div class="map-settings-row">
			<div class="map-settings-left">
				<div class="checkbox-row">
					<p-checkbox binary="true" [(ngModel)]="options.overwriteExistingTopologyMap"
						label="Overwrite existing map" inputId="ck-mo-oem"></p-checkbox>
				</div>
				<div class="checkbox-row">
					<p-checkbox binary="true" [(ngModel)]="options.showIfLabels"
						label="Show Interface Labels" inputId="ck-mo-sifl"></p-checkbox>
				</div>
			</div>
			<div class="map-settings-right">
				<div class="icon-row">
					<label>Icon Width:</label>
					<p-inputNumber [(ngModel)]="options.defaultIconWidth" [min]="8" [max]="200"
						[showButtons]="true" inputStyleClass="icon-spinner-input"></p-inputNumber>
				</div>
				<div class="icon-row">
					<label>Icon Height:</label>
					<p-inputNumber [(ngModel)]="options.defaultIconHeight" [min]="8" [max]="200"
						[showButtons]="true" inputStyleClass="icon-spinner-input"></p-inputNumber>
				</div>
			</div>
		</div>

		<div class="mt-3 mb-1 caption">Missing Devices go into the following PRTG Group.</div>
		<div class="form-row">
			<label class="form-label">Group:</label>
			<div class="form-input">
				<input type="text" pInputText [(ngModel)]="prtgTargetGroupId" style="width: 100%" />
			</div>
			<button type="button" pButton class="form-side-btn" label="Browse..."
				(click)="browseTargetGroup()" [disabled]="!selectedGuid"></button>
		</div>

		<div class="checkbox-row indent-group">
			<p-checkbox binary="true" [(ngModel)]="options.addPingSensors"
				label="Create PING sensor" inputId="ck-mo-aps"></p-checkbox>
		</div>
	</fieldset>

	}

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="export()" label="Export"
			[disabled]="!enableExport"></button>
		<button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
	</p-footer>

	<prtg-map-picker [(display)]="mapPickerVisible"
		[netViewGuid]="netViewGuid"
		[prtgSettingsGuid]="selectedGuid"
		title="PRTG Maps"
		(onSelect)="onMapPicked($event)"></prtg-map-picker>

	<prtg-group-picker [(display)]="groupPickerVisible"
		[netViewGuid]="netViewGuid"
		[prtgSettingsGuid]="selectedGuid"
		[title]="groupPickerTitle"
		(onSelect)="onGroupPicked($event)"></prtg-group-picker>

</p-dialog>
